/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { MatStatusIndicatorState as MSIS } from './mat-status-indicator-state';

@Component({
	selector: 'mat-status-indicator',
	templateUrl: './mat-status-indicator.component.html',
	styleUrls: ['./mat-status-indicator.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatStatusIndicatorComponent {
	@Input() public state: MSIS = MSIS.NotStarted;
	@Input() public scalePercent = 1.0;
	@Input() public spinnerThemePalette: ThemePalette = 'primary';
	@Input() public spinnerMode: ProgressSpinnerMode = 'determinate';
	@Input() public spinnerValue = 50;

	public notStarted = MSIS.NotStarted;
	public inProgress = MSIS.InProgress;
	public success = MSIS.Success;
	public failure = MSIS.Failure;
}
